var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3201_551",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 104
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.382812,
    y: 0.700195,
    width: 102.761,
    height: 102.761,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3201_551)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4196 70.1997C34.0498 75.2471 42.5018 77.7709 51.7757 77.7709C61.0495 77.7709 69.4976 75.2471 77.12 70.1997C84.7424 65.1523 90.4529 58.399 94.2514 49.9399C90.4529 41.4808 84.7384 34.7275 77.1082 29.6801C69.478 24.6326 61.026 22.1089 51.7521 22.1089C42.4783 22.1089 34.0302 24.6326 26.4078 29.6801C18.7854 34.7275 13.0749 41.4808 9.27637 49.9399C13.0749 58.399 18.7894 65.1523 26.4196 70.1997ZM73.9752 67.1202C67.2315 71.3662 59.8278 73.4892 51.7639 73.4892C43.7001 73.4892 36.2963 71.3662 29.5526 67.1202C22.809 62.8742 17.6531 57.1474 14.085 49.9399C17.6531 42.7324 22.809 37.0056 29.5526 32.7596C36.2963 28.5136 43.7001 26.3906 51.7639 26.3906C59.8278 26.3906 67.2315 28.5136 73.9752 32.7596C80.7188 37.0056 85.8747 42.7324 89.4428 49.9399C85.8747 57.1474 80.7188 62.8742 73.9752 67.1202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7833 65.5845C56.1344 65.5845 59.8264 64.0616 62.8593 61.0159C65.8921 57.9701 67.4086 54.2716 67.4086 49.9205C67.4086 45.5694 65.8857 41.8774 62.8399 38.8445C59.7941 35.8117 56.0957 34.2952 51.7445 34.2952C47.3934 34.2952 43.7014 35.8181 40.6685 38.8639C37.6357 41.9097 36.1193 45.6081 36.1193 49.9593C36.1193 54.3104 37.6421 58.0024 40.6879 61.0352C43.7337 64.0681 47.4322 65.5845 51.7833 65.5845ZM43.5752 58.1286C45.8231 60.3765 48.5526 61.5004 51.7639 61.5004C54.9752 61.5004 57.7048 60.3765 59.9526 58.1286C62.2005 55.8807 63.3245 53.1511 63.3245 49.9399C63.3245 46.7286 62.2005 43.999 59.9526 41.7511C57.7048 39.5033 54.9752 38.3793 51.7639 38.3793C48.5526 38.3793 45.8231 39.5033 43.5752 41.7511C41.3273 43.999 40.2033 46.7286 40.2033 49.9399C40.2033 53.1511 41.3273 55.8807 43.5752 58.1286Z",
    fill: "#FF6047"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/Vision.b65e523290a6b152f1bc40811b865a5b.svg";
export { ForwardRef as ReactComponent };